import Input from 'components/molecules/Input';
import { DownloadTemplateConfig as DownloadTemplateConfigType } from 'utils/gloo-types';
import CloudinaryImageUploader from 'components/organisms/CloudinaryImageUpload';
import { normalizedContentType } from 'utils/discover';

interface DownloadTemplateConfigProps {
  template?: any;
  handleChange: (data: any) => void;
  handleForm: (data: any) => void;
}
function DownloadTemplateConfig({ template, handleChange, handleForm }: DownloadTemplateConfigProps) {
  const templateConfig = template.config as DownloadTemplateConfigType;

  const updateConfigProperty = (key, value) => {
    handleChange((prevState) => {
      const config = prevState.config || {};
      config[key] = value;

      if (key === 'url') {
        const re = /(?:\.([^.]+))?$/;
        config.contentType = re.exec(value)[1];
      }

      return {
        ...prevState,
        config,
      };
    });

    handleForm((prevState) => {
      const config = prevState.config || {};
      config[key] = value;

      if (key === 'url') {
        const re = /(?:\.([^.]+))?$/;
        config.contentType = re.exec(value)[1];
      }

      return {
        ...prevState,
        config,
      };
    });
  };

  return (
    <>
      <CloudinaryImageUploader
        className="mb-4"
        imageWidth={600}
        preview
        existingImg={template?.config?.url}
        handleImgSelect={(imgUrl) => {
          updateConfigProperty('url', imgUrl);
        }}
        fileFilter="*"
      />
      <Input
        label="Content Type"
        className="my-2"
        value={normalizedContentType(templateConfig?.contentType)}
        disabled
        required
      />
    </>
  );
}

export default DownloadTemplateConfig;
